export default "__VITE_ASSET__n_H47p06__"